import createIcon from '../../createIcon';

/**
 * @component @name SendAndArchive
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuNSA5SDE3LjVMMS41IDJWOUwxMC41IDExTDEuNSAxM1YyMEw5LjUgMTYuNVYyMEM5LjUgMjEuMSAxMC40IDIyIDExLjUgMjJIMjAuNUMyMS42IDIyIDIyLjUgMjEuMSAyMi41IDIwVjExQzIyLjUgOS45IDIxLjYgOSAyMC41IDlaTTIwLjUgMjBIMTEuNVYxMUgyMC41VjIwWk0xNiAxOUwxMi41IDE1SDE0LjVWMTJIMTcuNVYxNUgxOS41TDE2IDE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SendAndArchive = createIcon('SendAndArchive', [
  [
    'path',
    {
      d: 'M20.5 9H17.5L1.5 2V9L10.5 11L1.5 13V20L9.5 16.5V20C9.5 21.1 10.4 22 11.5 22H20.5C21.6 22 22.5 21.1 22.5 20V11C22.5 9.9 21.6 9 20.5 9ZM20.5 20H11.5V11H20.5V20ZM16 19L12.5 15H14.5V12H17.5V15H19.5L16 19Z',
      key: 'hex299',
    },
  ],
]);

export default SendAndArchive;
